import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const cargoRefGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'QPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoRefGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.CARGO) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const cargoRefPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'QPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoPremium is 2
    if (appID !== constAppID.CARGO) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'cargoQuoteRef' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
